import React from 'react';
import { Modal, Form, DatePicker, Input, Button } from 'antd';

const ScheduleReportModal = ({ visible, onCancel, onSubmit, loading }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    onSubmit(values);
    form.resetFields();
  };

  return (
    <Modal
      title="Schedule Report Delivery"
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="scheduleTime"
          label="Schedule Date & Time"
          rules={[{ required: true, message: 'Please select date and time' }]}
        >
          <DatePicker showTime style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          name="email"
          label="Client Email"
          rules={[
            { required: true, message: 'Please input the email' },
            { type: 'email', message: 'The input is not a valid email' },
          ]}
        >
          <Input placeholder="client@example.com" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Schedule Report
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ScheduleReportModal;
